import type { Translations } from "../types";

const es: Translations = {
  nav: {
    features: "Funciones",
    pricing: "Precios",
    blog: "Blog",
    freeTools: "Herramientas Gratis",
    contact: "Contacto",
    startFree: "Empezar Gratis",
    solutions: "Soluciones",
    useCases: "Casos de Uso",
    switchToDark: "Cambiar a Modo Oscuro",
    switchToLight: "Cambiar a Modo Claro",
    solutionsToolsDesc: "Calculadoras, generadores y más",
    solutionsUseCasesDesc: "Mira Zapify en acción",
  },
  hero: {
    rotatingWords: ["DMs Automáticos", "Respuestas IA"],
    headline: "Responde a los comentarios de Instagram con",
    subheadline:
      "Responde automáticamente a los comentarios con DMs personalizados. Captura leads y haz crecer tu audiencia en piloto automático.",
    cta: "Comenzar Gratis",
    helperText: "Gratis para empezar",
    helperSeparator: "Configuración fácil",
    trustedBy: "Con la confianza de",
    creators: "5,000+ creadores",
    dmsSent: "DMs Enviados",
    dmsCount: "1,000,000+",
  },
  features: {
    headingTitle: "Todo lo que Necesitas para",
    headingHighlight: "Hacer Crecer tu",
    headingDescription:
      "Zapify te da control total sobre tu asistente de IA y automatización mientras ahorras horas de trabajo manual.",
    cta: "Activar 30 Días de Prueba Gratis",
    items: [
      {
        title: "Automatización de DMs",
        description:
          "Responde automáticamente a cada comentario de Instagram con un DM. Convierte el caos de DMs en leads calificados y ventas.",
      },
      {
        title: "Pedir que te Sigan",
        description:
          "Antes de compartir tu contenido exclusivo, pedimos al usuario que te siga.",
      },
      {
        title: "Respuestas con IA",
        description:
          "Respuestas que entienden el comentario y suenan como tú.",
      },
      {
        title: "Voz Totalmente Personalizable",
        description:
          "Elige tono y estilo, respuestas cortas/largas, y controla emojis + #hashtags.",
      },
      {
        title: "Soporte de Idiomas Global",
        description: "Habla su idioma, automáticamente.",
      },
      {
        title: "Recopilar Emails",
        description:
          "Construye tu lista de emails automáticamente desde los comentarios de Instagram.",
      },
      {
        title: "Acceso de Equipo",
        description:
          "Invita a miembros del equipo para gestionar respuestas, leads y conversaciones juntos.",
      },
      {
        title: "Múltiples Cuentas de Instagram",
        description:
          "Conecta y gestiona múltiples cuentas de Instagram desde un solo panel.",
      },
    ],
  },
  process: {
    headingTitle: "Empieza a Automatizar en",
    headingHighlight: "Minutos",
    headingDescription:
      "Sigue estos sencillos pasos para automatizar tus DMs",
    step: "Paso",
    cta: "Iniciar Automatización",
    steps: [
      {
        title: "Seleccionar Disparadores",
        description:
          "Elige qué publicaciones y palabras clave activan tu automatización.",
      },
      {
        title: "Automatizar Respuesta",
        description:
          "Crea mensajes personalizados con enlaces, ofertas o contenido para enviar automáticamente.",
      },
      {
        title: "Hazte Viral",
        description:
          "Crea más. Gestiona menos. La automatización hace el resto.",
      },
    ],
  },
  engagement: {
    headingTitle: "Convierte el Engagement de Instagram en",
    headingHighlight: "Ingresos en Piloto Automático",
    headingDescription:
      "Convierte cada comentario en oportunidades de venta. Gana dinero 24/7 mientras tu asistente de IA maneja las conversaciones",
    card1Title: "Aumenta los Clics en Enlaces",
    card1TitleLine2: "Conversiones",
    card1Description:
      "Convierte comentarios en tráfico directo. Entrega automáticamente tus ofertas, productos y contenido directamente a compradores interesados a través de DMs.",
    card2Title: "Agente de Ventas con IA 24/7",
    card2Description:
      "Nunca pierdas un comentario. Responde al instante y convierte conversaciones en ventas 24/7 mientras duermes.",
  },
  graph: {
    headingHighlight: "Multiplica tu",
    headingHighlightWord: "Alcance",
    headingDescription:
      "Mira cómo los DMs automatizados y las respuestas de IA multiplican tu tasa de engagement, crecimiento de seguidores y conversiones de ventas hasta 10x",
    title: "Impulsa el Engagement",
    by10x: "por 10x",
    subtitle: "Monetiza tu audiencia mientras duermes",
    description:
      "Responde a cada comentario, conviértelos en DMs e impulsa el engagement automáticamente.",
    afterZapify: "Después de Zapify Pro",
    cta: "Impulsa el Engagement Ahora",
  },
  testimonials: {
    headingTitle: "Mira Por Qué los Creadores de Instagram",
    headingHighlight: "Aman",
    headingDescription:
      "Historias de éxito reales de influencers y marcas que transformaron su engagement e ingresos en Instagram con automatización de IA",
    followers: "Seguidores",
  },
  faq: {
    headingTitle: "Preguntas",
    headingHighlight: "Frecuentes",
    headingDescription:
      "Todo lo que necesitas saber para empezar con Zapify",
    items: [
      {
        question: "¿Zapify funciona con cualquier cuenta de Instagram?",
        answer:
          "Zapify soporta cuentas profesionales de Instagram (Business o Creator). Las cuentas personales no son compatibles con la API.",
      },
      {
        question: "¿Zapify es accesible en móvil?",
        answer:
          "Sí, Zapify funciona muy bien en tu navegador móvil, puedes instalar la App del Navegador desde aquí.",
      },
      {
        question: "¿Las automatizaciones sonarán robóticas?",
        answer:
          "No. Zapify soporta controles de voz de marca (tono, longitud, uso de emojis) para que las respuestas de IA coincidan con tu estilo. Puedes editar cualquier mensaje y agregar un traspaso humano.",
      },
      {
        question: "¿Zapify está aprobado por Meta?",
        answer:
          "Zapify es un Proveedor de Tecnología Verificado por Meta, usamos las APIs oficiales de Instagram Graph. Seguimos los límites de tasa y las pautas de política para mantener tu cuenta segura.",
      },
      {
        question: "¿Es seguro usar Zapify?",
        answer:
          "Sí. Toda la autenticación usa OAuth seguro de Meta. Nunca pedimos tu contraseña de Instagram y respetamos los permisos de API que otorgas.",
      },
      {
        question: "¿Zapify es gratis?",
        answer:
          "Ofrecemos una prueba gratuita para que puedas probar las automatizaciones y ver resultados antes de actualizar.",
      },
      {
        question: "¿Tienen un programa de socios/afiliados?",
        answer:
          "Sí. Los socios aprobados ganan comisiones en nuevos registros y renovaciones. Solicita en nuestra página de Socios.",
      },
      {
        question: "¿Cómo contacto al soporte?",
        answer:
          "Usa el chat en la app o envíanos un email — la mayoría de las preguntas obtienen una respuesta el mismo día en días hábiles. También proporcionamos guías de configuración y plantillas de mejores prácticas.",
      },
    ],
  },
  verified: {
    headingTitle: "Programas",
    headingHighlight: "y Socios",
    headingDescription:
      "Nuestra startup aceptada por Stripe for Startups y Microsoft for Startups 2025",
    cta: "Ver Verificación",
    badge: "Verificado",
    heading: "Tu proveedor de tecnología verificado por Meta",
    description: "Nuestra empresa es aceptada oficialmente en Microsoft Startups for Founders y Stripe Startup Program.",
    missionNote: "Ver: Inicio → Secciones de héroe y problemas de creadores para nuestra misión y valor.",
    close: "Cerrar",
  },
  // Stats
  stats: {
    dmsSent: "DMs Enviados",
    followersGained: "Seguidores Ganados",
    commentsSent: "Comentarios Enviados",
    countries: "Países",
  },

  // Pricing
  pricing: {
    headingTitle: "Elige el plan que",
    headingHighlight: "se adapte a ti",
    headingDescription:
      "Precios flexibles para cada creador — cambia en cualquier momento y ahorra más con facturación anual",
    monthly: "Mensual",
    yearly: "Anual",
    get2MonthsFree: "Obtén 2 Meses Gratis",
    freeTrial: "Prueba Gratuita",
    freeTrialDesc: "Perfecto para empezar con Zapify.",
    starter: "Starter",
    starterDesc: "Ideal para creadores de contenido individuales.",
    professional: "Profesional",
    professionalDesc: "Ideal para startups y marcas pequeñas.",
    subscribe: "Suscribirse",
    startFreeTrial: "Iniciar 30 Días de Prueba Gratis",
    free: "GRATIS",
    noCreditCard: "Sin Tarjeta de Crédito",
    bestSeller: "Más Vendido",
    perMonth: "/mes",
    save: "Ahorra",
    unlimited: "Ilimitado",
    limited: "Limitado",
    email: "Email",
    priority: "Prioritario",
    automations: "Automatizaciones",
    dms: "DMs",
    aiReplies: "Respuestas IA",
    askToFollow: "Pedir que te Sigan",
    emailCollection: "Recopilación de Emails",
    igProfile: "Perfil IG",
    teamAccess: "Acceso de Equipo",
    support: "Soporte",
    // Category headers
    automationPower: "Potencia de Automatización",
    aiCapabilities: "Capacidades de IA",
    leadGeneration: "Generación de Leads",
    analyticsTeam: "Análisis y Equipo",
    supportPlatform: "Soporte y Plataforma",
    soonBadge: "Pronto",
    // AUTOMATION POWER features
    activeAutomations: "Automatizaciones activas",
    instagramAccounts: "Cuentas de Instagram",
    customTriggerWords: "Palabras desencadenantes personalizadas",
    instantDMReplies: "Respuestas DM instantáneas",
    commentToDMAutomation: "Automatización comentario-a-DM",
    storyReplyAutomation: "Automatización respuesta a historias",
    welcomeMessageAutomation: "Automatización mensaje de bienvenida",
    smartGreetingMessage: "Mensaje de saludo inteligente",
    unlimitedPostsStories: "Publicaciones e historias ilimitadas automatizadas",
    flexiblePostTargeting: "Segmentación flexible de publicaciones (siguiente, cualquiera, múltiples)",
    linkInDMCTAButtons: "Enlaces en DM y botones CTA",
    followGatedDMsLinks: "DMs y enlaces con seguimiento",
    instagramSafetyLimits: "Límites de seguridad de Instagram",
    customFlowBuilder: "Constructor de flujos personalizados",
    // AI CAPABILITIES features
    aiCommentReplies: "Respuestas a comentarios IA / mes",
    aiPoweredInstantReplies: "Respuestas instantáneas con IA",
    aiTrainedOnBrand: "IA entrenada en tu marca",
    // LEAD GENERATION features
    storedContacts: "Contactos almacenados",
    emailCaptureInsideDMs: "Captura de email en DMs",
    // ANALYTICS & TEAM features
    instagramInsights: "Insights de Instagram",
    monthlyPerformanceReports: "Informes de rendimiento mensuales",
    teamMembers: "Miembros del equipo",
    // SUPPORT & PLATFORM features
    customerSupport: "Atención al cliente",
    languageSupport: "Soporte de idiomas",
    platformBranding: "Branding de la Plataforma",
    offerTitle: "Oferta por Tiempo Limitado",
    offerDesc: "Regístrate hoy y obtén",
    offerBadge: "10% DE DESCUENTO HOY",
    limitedSpots: "Plazas Limitadas",
    offerEndsIn: "La oferta termina en",
    days: "Días",
    hours: "Horas",
    minutes: "Minutos",
    seconds: "Segundos",
    claimed: "reclamado",
    secureCheckout: "Pago seguro",
    noCreditCardRequired: "No se requiere tarjeta de crédito",
    copied: "¡COPIADO!",
    comparePlansEyebrow: "Cero relleno",
    comparePlansTitle: "Elige antes de que caduque tu próxima Story",
    comparePlansSubtitle:
      "Automatizaciones, DMs, IA, equipo: todo en una tabla para que sepas qué significa \"ilimitado\" de verdad. Léelo una vez, elige una vez, listo.",
    compareFeatureColumn: "Función",
    plansCtaBadgeLead: "Empieza con inteligencia.",
    plansCtaBadgeEmphasis: "Crea más.",
    plansCtaTitleLead: "No está hecho para retenerte.",
    plansCtaTitleGradient: "Está hecho para liberarte.",
    plansCtaSubtitle:
      "Muchas herramientas fomentan la dependencia. Nosotros lo contrario: automatiza lo que te agota, mantente donde importa y convierte charlas reales en impulso.",
    plansCtaSubtitleParagraph2:
      "Si todo fluye tan quieto que casi no piensas en nosotros—ahí cumplimos.",
    plansCtaBullet1: "Sin tarjeta de crédito",
    plansCtaBullet3: "Cancela cuando quieras, sin permanencia",
    plansCtaTrust: "Más de 5.000 creadores confían en nosotros",
    signupMixEyebrow: "Instantánea de altas",
    signupMixCountLabel: "altas en esta muestra",
    signupMixLeadTitle: "Cómo empezaron",
    signupMixLeadSubtitle:
      "La mayoría arranca con la prueba gratuita. El resto se reparte entre Starter y pasar directo a Professional.",
    signupMixLabelFreeTrial: "Prueba gratuita",
    signupMixLabelStarter: "Starter",
    signupMixLabelProfessional: "Professional",
  },

  // CTA
  cta: {
    readyToTransform: "¿Listo para Transformar tu Instagram?",
    joinThousands:
      "Únete a miles de creadores y marcas que usan Zapify para ganar seguidores, aumentar el engagement y ahorrar tiempo.",
    startForFree: "Empieza Gratis",
  },

  // Sticky
  sticky: {
    instantlyDm: "Envía DMs instantáneamente a quien comente en tu Instagram",
    limitedOffer: "Oferta por Tiempo Limitado - 10% DE DESCUENTO",
    endsIn: "Termina en",
    getStartedFree: "Comienza Gratis",
    start: "Empezar",
  },

  // Contact Page
  contactPage: {
    heading: "Contactar Soporte",
    subtitle:
      "Estamos aquí para ayudarte a crecer. Contáctanos para cualquier pregunta o soporte.",
    connectWithUs: "Conéctate con Nosotros",
    connectDescription: "Elige tu forma preferida de contactarnos",
    emailUs: "Escríbenos",
    emailResponse: "Responderemos en 24 horas",
    support: "Soporte",
    getInstantHelp: "Obtén ayuda instantánea en",
    scheduleMeet: "Agendar Reunión",
    followUs: "Síguenos",
    stayUpdated: "Mantente al día con las últimas novedades",
    responseTime: "Respuesta en 24h",
  },

  // Contact Form
  contactForm: {
    heading: "Envíanos un mensaje",
    description: "Completa el formulario a continuación y te responderemos",
    fullName: "Nombre completo",
    fullNamePlaceholder: "Ingresa tu nombre completo",
    emailAddress: "Correo electrónico",
    emailPlaceholder: "Ingresa tu correo electrónico",
    subject: "Asunto",
    subjectPlaceholder: "¿De qué se trata?",
    message: "Mensaje",
    messagePlaceholder: "Cuéntanos más sobre tu consulta...",
    sending: "Enviando...",
    sendMessage: "Enviar mensaje",
    successMessage: "¡Mensaje enviado con éxito! Te responderemos pronto.",
    errorMessage: "Algo salió mal. Por favor, inténtalo de nuevo.",
  },

  // Blog
  blog: {
    insightsStrategy: "Estrategia y perspectivas",
    masterTheArt: "Domina el arte del",
    instagramGrowth: "Crecimiento en Instagram",
    blogSubtitle: "Descubre guías de expertos, secretos de automatización y estrategias comprobadas para convertir tus comentarios en clientes.",
    searchPlaceholder: "Buscar estrategias, guías...",
    followForUpdates: "Síguenos para novedades",
    latestStories: "Últimas historias",
    minRead: "min de lectura",
    readStory: "Leer historia",
    featuredStory: "Historia destacada",
    freshDrop: "Recién publicado",
    readArticle: "Leer artículo",
    noArticlesFound: "No se encontraron artículos",
    noArticlesDescription: "No pudimos encontrar artículos que coincidan con tu búsqueda. Intenta ajustar tus filtros o vuelve más tarde.",
    clearSearch: "Limpiar búsqueda",
  },

  // Referral
  referral: {
    heading: "Únete a nuestro programa de",
    headingHighlight: "Referidos",
    description: "Recomienda Zapify a tus amigos y gana el 20% de los ingresos totales que generen con una suscripción de pago durante su primer año.",
    proSubscriber: "Suscriptor de Zapify Pro",
    minimumDms: "haber enviado un mínimo de 100 DMs",
    joinProgram: "Unirse al programa de referidos",
    termsOfService: "términos de servicio.",
    step1: "Paso 1",
    step1Title: "Obtén tu enlace de referido",
    step1Desc: "Regístrate en minutos — ¡sin aprobaciones necesarias! Si eres suscriptor Pro con más de 100 DMs enviados, puedes empezar a ganar.",
    referralLink: "Enlace de referido",
    copy: "Copiar",
    step2: "Paso 2",
    step2Title: "Comparte y promociona",
    step2Desc: "Copia tu enlace y compártelo donde quieras — Instagram, TikTok, YouTube, email o DMs. ¡Cuanto más compartas, más ganarás!",
    step3: "Paso 3",
    step3Title: "Gana 20% de comisión",
    step3Desc: "Cuando alguien se suscribe a un plan de pago usando tu enlace, ganas el 20% de sus pagos durante el primer año — ¡pagado mensualmente!",
    quickStats: "Estadísticas rápidas",
    clicks: "Clics",
    converted: "Convertidos",
    total: "Total",
    pending: "Pendiente",
    faqHeading: "Programa de referidos",
    faqSubheading: "Las preguntas más frecuentes sobre nuestro programa de referidos",
    faq1Q: "¿Qué es el programa de referidos de Zapify?",
    faq1A: "El programa de referidos de Zapify te permite ganar comisiones al recomendar nuevos usuarios a nuestra plataforma. Cuando alguien se registra en un plan de pago usando tu enlace único, ganas el 20% de sus cuotas de suscripción durante el primer año.",
    faq2Q: "¿Quién puede unirse al programa de referidos?",
    faq2A: "Para unirte, debes ser suscriptor de Zapify Pro y haber enviado al menos 100 DMs usando nuestras herramientas de automatización. Esto asegura que nuestros afiliados sean usuarios activos que puedan recomendar genuinamente la plataforma.",
    faq3Q: "¿Cómo y cuándo me pagan?",
    faq3A: "Las comisiones se pagan mensualmente a través de PayPal una vez que tus ganancias alcanzan el umbral mínimo de $50. Los pagos se procesan aproximadamente 30 días después del final del mes en que se generaron.",
    faq4Q: "¿Hay un límite en cuánto puedo ganar?",
    faq4A: "¡No! No hay un tope en tus ganancias. Cuantas más recomendaciones exitosas hagas, más ganarás.",
  },

  // Tools Page
  toolsPage: {
    heading: "Herramientas de Instagram",
    headingHighlight: "Gratis",
    description:
      "Calculadoras, generadores, formateadores y más — todo gratis, sin registro. Creado para creadores que quieren crecer de forma inteligente.",
    searchPlaceholder: "Buscar herramientas...",
    all: "Todas",
    noToolsFound: "No se encontraron herramientas que coincidan con tu búsqueda.",
    free: "Gratis",
    comingSoon: "Próximamente",
    relatedTools: "Herramientas relacionadas",
    relatedToolsDesc: "Más herramientas gratis para hacer crecer tu Instagram",
    viewAllTools: "Ver todas las herramientas gratis",
    frequentlyAsked: "Preguntas",
    questionsHighlight: "frecuentes",
    faqDescription: "Todo lo que necesitas saber sobre",
  },

  // Use Case
  useCase: {
    heading: "¿Qué puedes automatizar con",
    headingHighlight: "Zapify?",
    description: "Desde impulsar ventas hasta recopilar emails — descubre cómo los creadores y marcas usan Zapify para automatizar sus DMs de Instagram y crecer en piloto automático.",
    startForFree: "Empieza gratis",
    learnMore: "Más información",
    bottomCtaHeading: "¿Listo para automatizar tus DMs de Instagram?",
    bottomCtaDesc: "Únete a miles de creadores que usan Zapify para convertir conversaciones en ventas — automáticamente.",
    freeToStart: "Gratis para empezar · Configuración fácil",
  },

  footer: {
    description:
      "La herramienta #1 de automatización de DMs de Instagram, confiada por más de 5,000 creadores en todo el mundo.",
    product: "Producto",
    company: "Empresa",
    compare: "Comparar",
    howItWorks: "Cómo funciona",
    termsOfService: "Términos de Servicio",
    privacyPolicy: "Política de Privacidad",
    refundPolicy: "Política de Reembolso",
    contactUs: "Contáctanos",
    referralProgram: "Programa de Referidos",
    copyright: "Todos los derechos reservados.",
    builtWith: "Hecho con \u2764\uFE0F para creadores",
    useCasesHeading: "Casos de Uso",
    allUseCases: "Todos los Casos de Uso",
    sendLinksInDms: "Enviar Enlaces en DMs",
    autoRespondComments: "Auto-Responder Comentarios",
    collectEmails: "Recopilar Emails",
    storyReplies: "Respuestas a Stories",
  },

  // Auth
  auth: {
    welcomeToZapify: "Bienvenido a Zapify",
    setItUpOnce: "Configúralo una vez. Deja que la IA haga el resto.",
    recommended: "Recomendado",
    continueWithInstagram: "Continuar con Instagram",
    continueWithGoogle: "Continuar con Google",
    redirecting: "Redirigiendo...",
    orContinueWithEmail: "o continúa con email",
    emailAddress: "Correo electrónico",
    emailRequired: "El correo electrónico es obligatorio",
    validEmail: "Por favor, ingresa un correo válido",
    sendingCode: "Enviando código...",
    startFree: "Empezar gratis",
    enterVerificationCode: "Ingresa el código de verificación",
    weSentCode: "Enviamos un código de 6 dígitos a",
    otpRequired: "El OTP es obligatorio",
    otpDigits: "El OTP debe tener 6 dígitos",
    verifying: "Verificando...",
    verifyAndContinue: "Verificar y continuar",
    useDifferentEmail: "Usar otro correo",
    agreeToTerms: "Al continuar, aceptas nuestros",
    termsOfService: "Términos de Servicio",
    and: "y",
    privacyPolicy: "Política de Privacidad",
    haveDiscountCode: "¿Tienes un código de descuento?",
    discountCode: "Código de descuento",
    enterCode: "Ingresa el código",
    apply: "Aplicar",
    applied: "Aplicado",
    congratsDiscount: "¡Felicidades! Tienes un 20% de descuento adicional.",
    invalidCode: "Código de descuento no válido",
    redirectingToDashboard: "Redirigiendo al panel...",
    referralBannerText: "¡Felicidades! Tienes un 20% de descuento adicional.",
    extendedTrialBannerText: "¡Felicidades! Has desbloqueado {days} días de prueba gratuita.",
  },

  // Comparison
  comparison: {
    updatedDate: "Actualizado en marzo de 2026",
    startFreeNoCreditCard: "Empieza gratis — Sin tarjeta de crédito",
    seeFullComparison: "Ver comparación completa",
    quickAnswer: "Respuesta rápida",
    featureComparison: "Comparación función por función",
    samePriceTitle: "Mismo precio, pero ¿qué obtienes realmente?",
    aiVsKeywords: "Reconocimiento de intención con IA vs plantillas básicas de palabras clave",
    userComments: "Lo que los usuarios realmente escriben en los comentarios:",
    bottomCtaHeading: "¿Listo para probar la alternativa más inteligente?",
    bottomCtaDesc: "Únete a miles de creadores que se cambiaron a Zapify para la automatización de Instagram con IA.",
    getStarted: "Empezar gratis",
    freeToStart: "Gratis para empezar · Sin tarjeta de crédito",
    feature: "Función",
    category: "Categoría",
    pricingTiers: "Niveles de precios",
    faq: "Preguntas frecuentes",
  },

  // Legal
  legal: {
    lastUpdated: "Última actualización",
    haveQuestions: "¿Tienes preguntas?",
    contactEmail: "No dudes en escribirnos a",
    returnToWebsite: "Volver al sitio web",
    termsOfService: "Términos de Servicio",
    privacyPolicy: "Política de Privacidad",
    refundPolicy: "Política de Reembolso",
    dataDeletion: "Política de eliminación de datos",
  },

  // Use Case Layout
  useCaseLayout: {
    startForFree: "Empieza gratis",
    freeToStart: "Gratis para empezar · Configuración fácil",
    frequentlyAsked: "Preguntas",
    questionsHighlight: "frecuentes",
    readyToAutomate: "¿Listo para automatizar tus DMs de Instagram?",
    readyToAutomateDesc: "Únete a miles de creadores que usan Zapify para convertir conversaciones en ventas — automáticamente.",
    trigger: "Disparador:",
    response: "Respuesta:",
    exploreMore: "Explorar más",
  },
};

export default es;
